import { usersAction, UserActionTypes, UserState } from "../../types/user";

const initialState: UserState = {
  login: undefined,
  success: false,
  loading: false,
  error: null,
  data: {
    accessToken: "",
    name: "",
    roles: [],
    groups: [],
    statuses: {},
  },
  loggedIn: undefined,
};

export const userReducer = (
  state: UserState = initialState,
  action: usersAction
): UserState => {
  switch (action.type) {
    case UserActionTypes.POST_USER_LOGIN: {
      return { ...state, login: action.payload };
    }
    case UserActionTypes.POST_USER_TOKEN: {
      return { ...state, loading: true };
    }
    case UserActionTypes.POST_USER_TOKEN_SUCCESS: {
      return {
        ...state,
        success: true,
        loading: false,
        loggedIn: true,
        data: { ...state.data, ...action.payload },
      };
    }

    case UserActionTypes.POST_USER_TOKEN_ERROR: {
      return {
        ...initialState,
        success: true,
        loggedIn: false,
        error: action.payload,
      };
    }

    case UserActionTypes.POST_USER_INFO_SUCCESS: {
      return {
        ...state,
        success: true,
        loading: false,
        loggedIn: true,
        data: { ...state.data, ...action.payload },
      };
    }

    case UserActionTypes.POST_USER_INFO_ERROR: {
      return {
        ...initialState,
        success: true,
        loggedIn: false,
        error: action.payload,
      };
    }

    case UserActionTypes.UPDATE_TOKEN: {
      return {
        ...initialState,
        success: true,
        loggedIn: true,
        data: action.payload,
      };
    }
    case UserActionTypes.REMOVE_TOKEN: {
      return {
        ...initialState,
        success: true,
        loggedIn: false,
      };
    }
    default:
      return state;
  }
};
